"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.V5BaseModel = void 0;
const BaseModel_1 = require("./BaseModel");
class V5BaseModel extends BaseModel_1.BaseModel {
    constructor(type, options) {
        super(options);
        this.type = type;
    }
    get model() {
        return this.options.model;
    }
    get id() {
        return this.model.id;
    }
    get org() {
        return this.options.banks.orgBank.org(this.org_id);
    }
    getOrg() {
        return this.options.banks.orgBank.resolve(this.org_id);
    }
    async getResourceSelector() {
        const parents = await this.getParentResourceSelectors();
        return {
            id: this.id,
            model: this.type,
            ...(parents.length > 0
                ? {
                    parents: parents
                }
                : {})
        };
    }
    async getComparativeResource() {
        return {
            scope: this.org_id,
            selector: await this.getResourceSelector()
        };
    }
}
exports.V5BaseModel = V5BaseModel;
